import * as Yup from "yup";
import {dropDownErrorMsg} from "./YupErrorMessages";
import {ascii} from "../utils";

export const defaultAddressFields = {
    flat_door_building: "",
    premise_building_village: "",
    road_street: "",
    area_locality: "",
    town_city_district: "",
    country: "-1",
};

export const defaultAddressValidationSchema = Yup.object().shape({
    flat_door_building: ascii.required("Flat/Door/Building is required"),
    premise_building_village: ascii.nullable(),
    road_street: ascii.nullable(),
    area_locality: ascii.required("Area/Locality is required"),
    town_city_district: ascii.required("Town/City/District is required"),
    country: ascii.notOneOf(["-1"], dropDownErrorMsg).required("Country is required"),
});
